import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

import App from './App';
import { AuthProvider } from './hoc/AuthProvider';
import { MtgProvider } from './hoc/MtgProvider';
import { SetProvider } from './hoc/SetProvider';
// import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root'));
document.body.classList.add('initialised');
root.render(
	<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
		<MtgProvider>
			<SetProvider>
				<AuthProvider>
					<App />
				</AuthProvider>
			</SetProvider>
		</MtgProvider>
	</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
